(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-produc"] && !Shopify.designMode) return;
  try {
    
  class OklStickyAtc extends HTMLElement {
    connectedCallback() {
      this.form = document.querySelector('product-form form[action*="/cart/add"]');
      this.ancla = document.querySelector('.product-form__buttons');
      if (!this.form || !this.ancla) return;

      this.boton = this.querySelector('[data-okl-add]');
      this.etiqueta = this.querySelector('[data-okl-label]');
      this.precio = this.querySelector('[data-okl-price]');
      this.variante = this.querySelector('[data-okl-variant]');

      // El botón no reimplementa nada: dispara el envío del formulario real,
      // que es el que Dawn ya intercepta para agregar por AJAX.
      this.boton.addEventListener('click', () => {
        if (this.boton.disabled) return;
        if (typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit();
        } else {
          this.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });

      // Se muestra cuando el botón principal ya quedó ARRIBA de la pantalla.
      // Si está abajo (todavía no se llegó a él) no tiene sentido taparlo.
      this.observador = new IntersectionObserver(
        ([e]) => {
          const pasoDeLargo = !e.isIntersecting && e.boundingClientRect.top < 0;
          this.toggleAttribute('data-oculto', !pasoDeLargo);
        },
        { threshold: 0 }
      );
      this.observador.observe(this.ancla);

      // Al tocar una talla se refleja de una: el radio ya quedó marcado, no
      // hay que esperar a que Dawn termine de redibujar.
      this.form.addEventListener('change', () => this.sincronizar());

      // Y cuando Dawn sí redibuja la ficha (precio, stock), se vuelve a leer.
      // En vez de recalcular aquí, se copia lo que la ficha ya muestra: así
      // no hay dos fuentes de verdad que se puedan contradecir.
      const info = document.querySelector('product-info') || this.form.closest('section');
      if (info) {
        this.mo = new MutationObserver(() => {
          cancelAnimationFrame(this.pendiente);
          this.pendiente = requestAnimationFrame(() => this.sincronizar());
        });
        this.mo.observe(info, { childList: true, subtree: true });
      }
      this.sincronizar();
    }

    disconnectedCallback() {
      if (this.observador) this.observador.disconnect();
      if (this.mo) this.mo.disconnect();
    }

    sincronizar() {
      const principal = document.querySelector('.product-form__submit');
      if (principal) {
        this.boton.disabled = principal.disabled;
        const txt = principal.querySelector('span');
        if (txt && this.etiqueta && principal.disabled) {
          this.etiqueta.textContent = txt.textContent.trim();
        }
      }

      const p = document.querySelector('.product__info-container .price');
      if (p && this.precio) {
        const rebaja = p.querySelector('.price-item--sale');
        const antes = p.querySelector('.price-item--regular');
        const enOferta = p.classList.contains('price--on-sale');
        if (enOferta && rebaja) {
          this.precio.innerHTML =
            '<span class="okl-satc__now"></span><s class="okl-satc__was"></s>';
          this.precio.firstChild.textContent = rebaja.textContent.trim();
          this.precio.lastChild.textContent = antes ? antes.textContent.trim() : '';
        } else if (rebaja || antes) {
          this.precio.innerHTML = '<span class="okl-satc__plain"></span>';
          this.precio.firstChild.textContent = (rebaja || antes).textContent.trim();
        }
      }

      const elegida = document.querySelector(
        '.product-form__input--pill input[type="radio"]:checked'
      );
      if (elegida && this.variante) this.variante.textContent = elegida.value;
    }
  }

  if (!customElements.get('okl-sticky-atc')) {
    customElements.define('okl-sticky-atc', OklStickyAtc);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
